import gsap from 'gsap';

const teamCards = document.querySelectorAll('.team_item');
const isHoverSupported = window.matchMedia('(hover: hover)').matches;

document.addEventListener('DOMContentLoaded', (event) => {
    teamCards.forEach((card, i) => {
        const info = card.querySelector('.team_info-wrap');
        if (isHoverSupported) {
            card.addEventListener('mouseover', (e) => {
                gsap.to(info, {
                    x: '0%',
                    ease: 'power4.out',
                });
            });
            card.addEventListener('mouseleave', (e) => {
                const tl = gsap.timeline();
                tl.to(info, {
                    x: '100%',
                }).to(info, {
                    x: '-100%',
                    duration: 0,
                });
            });
        } else {
            card.addEventListener('click', (e) => {
                gsap.to(info, {
                    x: '0%',
                    ease: 'power4.out',
                });
            });
            card.addEventListener('click', (e) => {
                if (e.target.classList.contains('team_info-close')) {
                    const tl = gsap.timeline();
                    tl.to(info, {
                        x: '100%',
                    }).to(info, {
                        x: '-100%',
                        duration: 0,
                    });
                }
            });
        }
    });
});
